<template>
<div>
  <div v-if="!dashBoardDispMode">
    <v-row no-gutters justify="center" class="pt-3" style="height:196px;"  v-show="isLoading">
      <div class="donutSpinner"></div>
    </v-row>
    <v-row no-gutters class="px-1 pt-3 pb-0" v-show="!isLoading">
      <v-col :cols="4">
        <v-row no-gutters justify="center">
          <svg xmlns="http://www.w3.org/2000/svg" width="108" height="108" viewBox="0 0 72 72" v-if="hensachiMode==0">
            <g id="グループ_58088" data-name="グループ 58088" transform="translate(-304 -342)">
              <circle id="楕円形_519" data-name="楕円形 519" cx="36" cy="36" r="36" transform="translate(304 342)" fill="#2d71bf"/>
              <text id="普通" transform="translate(340 399)" fill="#fff" font-size="15" font-family="YuGo-Bold, YuGothic" font-weight="700"><tspan x="-15" y="0">普通</tspan></text>
              <g id="gasoline-pump" transform="translate(313 355.209)">
                <path id="パス_128900" data-name="パス 128900" d="M122.047,80.837A.837.837,0,0,0,121.21,80h-8.372a.837.837,0,0,0-.837.837v6.7a.837.837,0,0,0,.837.837h8.372a.837.837,0,0,0,.837-.837ZM120.372,86.7h-6.7V81.674h6.7Z" transform="translate(-90.977 -75.814)" fill="#fff"/>
                <path id="パス_128901" data-name="パス 128901" d="M40.674,5.937,37.335,4.262a.836.836,0,1,0-.741,1.5l1.272.635a.845.845,0,0,0-.078.29,2.692,2.692,0,0,0,1.655,2.357v10.2a.837.837,0,0,1-1.674,0v-6.7a4.446,4.446,0,0,0-3.349-4.1V3.337A3.308,3.308,0,0,0,31.11,0H21.063a3.377,3.377,0,0,0-3.389,3.337V22.076l-1.212.606A.837.837,0,0,0,16,23.43v2.512a.883.883,0,0,0,.877.849H35.3a.815.815,0,0,0,.8-.849V23.43a.837.837,0,0,0-.463-.749l-1.212-.606V10.189a2.711,2.711,0,0,1,1.674,2.357v6.7a2.512,2.512,0,1,0,5.023,0V6.686A.819.819,0,0,0,40.674,5.937Zm-6.255,19.18H17.674V23.948l1.212-.606a.837.837,0,0,0,.463-.749V3.337a1.7,1.7,0,0,1,1.714-1.662H31.11a1.632,1.632,0,0,1,1.635,1.662V22.593a.837.837,0,0,0,.463.749l1.212.606Z" fill="#fff"/>
              </g>
            </g>
          </svg>

          <svg xmlns="http://www.w3.org/2000/svg" width="108" height="108" viewBox="0 0 72 72" v-if="hensachiMode==1">
            <g id="グループ_58088" data-name="グループ 58088" transform="translate(-304 -342)">
              <circle id="楕円形_519" data-name="楕円形 519" cx="36" cy="36" r="36" transform="translate(304 342)" fill="#0ac80a"/>
              <text id="良い" transform="translate(340 399)" fill="#fff" font-size="15" font-family="YuGo-Bold, YuGothic" font-weight="700"><tspan x="-15" y="0">良い</tspan></text>
              <g id="gasoline-pump" transform="translate(313 355.209)">
                <path id="パス_128900" data-name="パス 128900" d="M122.047,80.837A.837.837,0,0,0,121.21,80h-8.372a.837.837,0,0,0-.837.837v6.7a.837.837,0,0,0,.837.837h8.372a.837.837,0,0,0,.837-.837ZM120.372,86.7h-6.7V81.674h6.7Z" transform="translate(-90.977 -75.814)" fill="#fff"/>
                <path id="パス_128901" data-name="パス 128901" d="M40.674,5.937,37.335,4.262a.836.836,0,1,0-.741,1.5l1.272.635a.845.845,0,0,0-.078.29,2.692,2.692,0,0,0,1.655,2.357v10.2a.837.837,0,0,1-1.674,0v-6.7a4.446,4.446,0,0,0-3.349-4.1V3.337A3.308,3.308,0,0,0,31.11,0H21.063a3.377,3.377,0,0,0-3.389,3.337V22.076l-1.212.606A.837.837,0,0,0,16,23.43v2.512a.883.883,0,0,0,.877.849H35.3a.815.815,0,0,0,.8-.849V23.43a.837.837,0,0,0-.463-.749l-1.212-.606V10.189a2.711,2.711,0,0,1,1.674,2.357v6.7a2.512,2.512,0,1,0,5.023,0V6.686A.819.819,0,0,0,40.674,5.937Zm-6.255,19.18H17.674V23.948l1.212-.606a.837.837,0,0,0,.463-.749V3.337a1.7,1.7,0,0,1,1.714-1.662H31.11a1.632,1.632,0,0,1,1.635,1.662V22.593a.837.837,0,0,0,.463.749l1.212.606Z" fill="#fff"/>
                <g id="グループ_58099" data-name="グループ 58099" transform="translate(15.502 0.928)">
                  <g id="楕円形_520" data-name="楕円形 520" transform="translate(6.316 13.135)" fill="none" stroke="#fff" stroke-width="0.75">
                    <circle cx="4.229" cy="4.229" r="4.229" stroke="none"/>
                    <circle cx="4.229" cy="4.229" r="3.854" fill="none"/>
                  </g>
                  <g id="楕円形_521" data-name="楕円形 521" transform="translate(8.063 14.881)" fill="none" stroke="#fff" stroke-width="0.75">
                    <circle cx="2.482" cy="2.482" r="2.482" stroke="none"/>
                    <circle cx="2.482" cy="2.482" r="2.107" fill="none"/>
                  </g>
                </g>
              </g>
            </g>
          </svg>

          <svg xmlns="http://www.w3.org/2000/svg" width="108" height="108" viewBox="0 0 72 72" v-if="hensachiMode==2">
            <g id="グループ_58088" data-name="グループ 58088" transform="translate(-304 -342)">
              <circle id="楕円形_519" data-name="楕円形 519" cx="36" cy="36" r="36" transform="translate(304 342)" fill="#db4343"/>
              <text id="悪い" transform="translate(340 399)" fill="#fff" font-size="15" font-family="YuGo-Bold, YuGothic" font-weight="700"><tspan x="-15" y="0">悪い</tspan></text>
              <g id="gasoline-pump" transform="translate(313 355.209)">
                <path id="パス_128900" data-name="パス 128900" d="M122.047,80.837A.837.837,0,0,0,121.21,80h-8.372a.837.837,0,0,0-.837.837v6.7a.837.837,0,0,0,.837.837h8.372a.837.837,0,0,0,.837-.837ZM120.372,86.7h-6.7V81.674h6.7Z" transform="translate(-90.977 -75.814)" fill="#fff"/>
                <path id="パス_128901" data-name="パス 128901" d="M40.674,5.937,37.335,4.262a.836.836,0,1,0-.741,1.5l1.272.635a.845.845,0,0,0-.078.29,2.692,2.692,0,0,0,1.655,2.357v10.2a.837.837,0,0,1-1.674,0v-6.7a4.446,4.446,0,0,0-3.349-4.1V3.337A3.308,3.308,0,0,0,31.11,0H21.063a3.377,3.377,0,0,0-3.389,3.337V22.076l-1.212.606A.837.837,0,0,0,16,23.43v2.512a.883.883,0,0,0,.877.849H35.3a.815.815,0,0,0,.8-.849V23.43a.837.837,0,0,0-.463-.749l-1.212-.606V10.189a2.711,2.711,0,0,1,1.674,2.357v6.7a2.512,2.512,0,1,0,5.023,0V6.686A.819.819,0,0,0,40.674,5.937Zm-6.255,19.18H17.674V23.948l1.212-.606a.837.837,0,0,0,.463-.749V3.337a1.7,1.7,0,0,1,1.714-1.662H31.11a1.632,1.632,0,0,1,1.635,1.662V22.593a.837.837,0,0,0,.463.749l1.212.606Z" fill="#fff"/>
              </g>
              <g id="グループ_58100" data-name="グループ 58100" transform="translate(-28.693 -11)">
                <line id="線_833" data-name="線 833" x2="6.613" y2="6.613" transform="translate(364.193 381.193)" fill="none" stroke="#fff" stroke-width="1.5"/>
                <line id="線_834" data-name="線 834" x1="6.613" y2="6.613" transform="translate(364.193 381.193)" fill="none" stroke="#fff" stroke-width="1.5"/>
              </g>
            </g>
          </svg>
        </v-row>
      </v-col>
      <v-col :cols="8">
        <v-row no-gutters class="my-1 px-5">
          <span class="kyuyu_summary_text_num">
            {{kyuyuKingakuJisseki}}
          </span>
          <span class="kyuyu_summary_text">
            円
          </span>
        </v-row>
        <v-row no-gutters class="my-1 px-5">
          <span class="kyuyu_info_text">
            想定目標比較
          </span>
        </v-row>
        <v-row no-gutters class="my-1 px-5">
          <span class="zenkoku_summary_text_num">
            {{zenkokuShihyoKingaku}}
          </span>
          <span class="kyuyu_info_text" style="margin-top:8px">
            円
          </span>
          <br class="block-sm-and-down hidden-md-and-up" />
          <span class="kyuyu_hensachi_icon" :style="setHensachiIconColor" style="vertical-align: top;">
            <span v-if="hensachiMode==0">±</span>
            <span v-if="hensachiMode==1">↓</span>
            <span v-if="hensachiMode==2">↑</span>
            {{kyuyuKingakuHensachi}}円
          </span>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters v-show="!isLoading">
      <v-col :cols="12" class="condition-area pa-2">
        <span class="kyuyu_info_text_bold">
          想定目標より
        </span>
        <span :style="setHensachiTextColor">
          <span class="kyuyu_hensachi_num">
            {{kyuyuKingakuHensachi}}
          </span>
          <span class="kyuyu_hensachi_text" >
              円
          </span>
        </span>
        <span class="kyuyu_info_text_bold">
          <span v-if="hensachiMode==2">高く運行しています。</span>
          <span v-else>安く運行できています！</span>
        </span>
      </v-col>
    </v-row>
  </div>
  <div v-if="dashBoardDispMode">
    <v-row no-gutters class="px-1 pt-3 pb-0">
      <v-col :cols="5">
        <v-row no-gutters="">
          <v-col :cols="4">
            <v-row no-gutters justify="center">
              <svg xmlns="http://www.w3.org/2000/svg" width="108" height="108" viewBox="0 0 72 72" v-if="hensachiMode==0">
                <g id="グループ_58088" data-name="グループ 58088" transform="translate(-304 -342)">
                  <circle id="楕円形_519" data-name="楕円形 519" cx="36" cy="36" r="36" transform="translate(304 342)" fill="#2d71bf"/>
                  <text id="普通" transform="translate(340 399)" fill="#fff" font-size="15" font-family="YuGo-Bold, YuGothic" font-weight="700"><tspan x="-15" y="0">普通</tspan></text>
                  <g id="gasoline-pump" transform="translate(313 355.209)">
                    <path id="パス_128900" data-name="パス 128900" d="M122.047,80.837A.837.837,0,0,0,121.21,80h-8.372a.837.837,0,0,0-.837.837v6.7a.837.837,0,0,0,.837.837h8.372a.837.837,0,0,0,.837-.837ZM120.372,86.7h-6.7V81.674h6.7Z" transform="translate(-90.977 -75.814)" fill="#fff"/>
                    <path id="パス_128901" data-name="パス 128901" d="M40.674,5.937,37.335,4.262a.836.836,0,1,0-.741,1.5l1.272.635a.845.845,0,0,0-.078.29,2.692,2.692,0,0,0,1.655,2.357v10.2a.837.837,0,0,1-1.674,0v-6.7a4.446,4.446,0,0,0-3.349-4.1V3.337A3.308,3.308,0,0,0,31.11,0H21.063a3.377,3.377,0,0,0-3.389,3.337V22.076l-1.212.606A.837.837,0,0,0,16,23.43v2.512a.883.883,0,0,0,.877.849H35.3a.815.815,0,0,0,.8-.849V23.43a.837.837,0,0,0-.463-.749l-1.212-.606V10.189a2.711,2.711,0,0,1,1.674,2.357v6.7a2.512,2.512,0,1,0,5.023,0V6.686A.819.819,0,0,0,40.674,5.937Zm-6.255,19.18H17.674V23.948l1.212-.606a.837.837,0,0,0,.463-.749V3.337a1.7,1.7,0,0,1,1.714-1.662H31.11a1.632,1.632,0,0,1,1.635,1.662V22.593a.837.837,0,0,0,.463.749l1.212.606Z" fill="#fff"/>
                  </g>
                </g>
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="108" height="108" viewBox="0 0 72 72" v-if="hensachiMode==1">
                <g id="グループ_58088" data-name="グループ 58088" transform="translate(-304 -342)">
                  <circle id="楕円形_519" data-name="楕円形 519" cx="36" cy="36" r="36" transform="translate(304 342)" fill="#0ac80a"/>
                  <text id="良い" transform="translate(340 399)" fill="#fff" font-size="15" font-family="YuGo-Bold, YuGothic" font-weight="700"><tspan x="-15" y="0">良い</tspan></text>
                  <g id="gasoline-pump" transform="translate(313 355.209)">
                    <path id="パス_128900" data-name="パス 128900" d="M122.047,80.837A.837.837,0,0,0,121.21,80h-8.372a.837.837,0,0,0-.837.837v6.7a.837.837,0,0,0,.837.837h8.372a.837.837,0,0,0,.837-.837ZM120.372,86.7h-6.7V81.674h6.7Z" transform="translate(-90.977 -75.814)" fill="#fff"/>
                    <path id="パス_128901" data-name="パス 128901" d="M40.674,5.937,37.335,4.262a.836.836,0,1,0-.741,1.5l1.272.635a.845.845,0,0,0-.078.29,2.692,2.692,0,0,0,1.655,2.357v10.2a.837.837,0,0,1-1.674,0v-6.7a4.446,4.446,0,0,0-3.349-4.1V3.337A3.308,3.308,0,0,0,31.11,0H21.063a3.377,3.377,0,0,0-3.389,3.337V22.076l-1.212.606A.837.837,0,0,0,16,23.43v2.512a.883.883,0,0,0,.877.849H35.3a.815.815,0,0,0,.8-.849V23.43a.837.837,0,0,0-.463-.749l-1.212-.606V10.189a2.711,2.711,0,0,1,1.674,2.357v6.7a2.512,2.512,0,1,0,5.023,0V6.686A.819.819,0,0,0,40.674,5.937Zm-6.255,19.18H17.674V23.948l1.212-.606a.837.837,0,0,0,.463-.749V3.337a1.7,1.7,0,0,1,1.714-1.662H31.11a1.632,1.632,0,0,1,1.635,1.662V22.593a.837.837,0,0,0,.463.749l1.212.606Z" fill="#fff"/>
                    <g id="グループ_58099" data-name="グループ 58099" transform="translate(15.502 0.928)">
                      <g id="楕円形_520" data-name="楕円形 520" transform="translate(6.316 13.135)" fill="none" stroke="#fff" stroke-width="0.75">
                        <circle cx="4.229" cy="4.229" r="4.229" stroke="none"/>
                        <circle cx="4.229" cy="4.229" r="3.854" fill="none"/>
                      </g>
                      <g id="楕円形_521" data-name="楕円形 521" transform="translate(8.063 14.881)" fill="none" stroke="#fff" stroke-width="0.75">
                        <circle cx="2.482" cy="2.482" r="2.482" stroke="none"/>
                        <circle cx="2.482" cy="2.482" r="2.107" fill="none"/>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="108" height="108" viewBox="0 0 72 72" v-if="hensachiMode==2">
                <g id="グループ_58088" data-name="グループ 58088" transform="translate(-304 -342)">
                  <circle id="楕円形_519" data-name="楕円形 519" cx="36" cy="36" r="36" transform="translate(304 342)" fill="#db4343"/>
                  <text id="悪い" transform="translate(340 399)" fill="#fff" font-size="15" font-family="YuGo-Bold, YuGothic" font-weight="700"><tspan x="-15" y="0">悪い</tspan></text>
                  <g id="gasoline-pump" transform="translate(313 355.209)">
                    <path id="パス_128900" data-name="パス 128900" d="M122.047,80.837A.837.837,0,0,0,121.21,80h-8.372a.837.837,0,0,0-.837.837v6.7a.837.837,0,0,0,.837.837h8.372a.837.837,0,0,0,.837-.837ZM120.372,86.7h-6.7V81.674h6.7Z" transform="translate(-90.977 -75.814)" fill="#fff"/>
                    <path id="パス_128901" data-name="パス 128901" d="M40.674,5.937,37.335,4.262a.836.836,0,1,0-.741,1.5l1.272.635a.845.845,0,0,0-.078.29,2.692,2.692,0,0,0,1.655,2.357v10.2a.837.837,0,0,1-1.674,0v-6.7a4.446,4.446,0,0,0-3.349-4.1V3.337A3.308,3.308,0,0,0,31.11,0H21.063a3.377,3.377,0,0,0-3.389,3.337V22.076l-1.212.606A.837.837,0,0,0,16,23.43v2.512a.883.883,0,0,0,.877.849H35.3a.815.815,0,0,0,.8-.849V23.43a.837.837,0,0,0-.463-.749l-1.212-.606V10.189a2.711,2.711,0,0,1,1.674,2.357v6.7a2.512,2.512,0,1,0,5.023,0V6.686A.819.819,0,0,0,40.674,5.937Zm-6.255,19.18H17.674V23.948l1.212-.606a.837.837,0,0,0,.463-.749V3.337a1.7,1.7,0,0,1,1.714-1.662H31.11a1.632,1.632,0,0,1,1.635,1.662V22.593a.837.837,0,0,0,.463.749l1.212.606Z" fill="#fff"/>
                  </g>
                  <g id="グループ_58100" data-name="グループ 58100" transform="translate(-28.693 -11)">
                    <line id="線_833" data-name="線 833" x2="6.613" y2="6.613" transform="translate(364.193 381.193)" fill="none" stroke="#fff" stroke-width="1.5"/>
                    <line id="線_834" data-name="線 834" x1="6.613" y2="6.613" transform="translate(364.193 381.193)" fill="none" stroke="#fff" stroke-width="1.5"/>
                  </g>
                </g>
              </svg>
            </v-row>
          </v-col>
          <v-col :cols="8">
            <v-row no-gutters class="my-1">
              <v-col :cols="12">
                <span class="kyuyu_summary_text_num">
                  {{kyuyuKingakuJisseki}}
                </span>
                <span class="kyuyu_summary_text">
                  円
                </span>
              </v-col>
            </v-row>
            <v-row no-gutters class="my-1">
              <v-col :cols="12">
                <span class="kyuyu_info_text">
                  想定目標比較
                </span>
              </v-col>
            </v-row>
            <v-row no-gutters class="my-1">
              <v-col :cols="12">
                <span class="zenkoku_summary_text_num">
                  {{zenkokuShihyoKingaku}}
                </span>
                <span class="kyuyu_info_text">
                  円
                </span>
                <span class="kyuyu_hensachi_icon" :style="setHensachiIconColor">
                  <span v-if="hensachiMode==0">±</span>
                  <span v-if="hensachiMode==1">↓</span>
                  <span v-if="hensachiMode==2">↑</span>
                  {{kyuyuKingakuHensachi}}円
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col :cols="7"  style="align-self: center;">
        <div class="condition-area px-2">
          <span class="kyuyu_info_text_bold_dashboard">
              想定目標より
          </span>
          <span :style="setHensachiTextColor">
            <span class="kyuyu_hensachi_num_dashboard">
              {{kyuyuKingakuHensachi}}
            </span>
            <span class="kyuyu_hensachi_text_dashboard" >
                円
            </span>
          </span>
          <span class="kyuyu_info_text_bold_dashboard">
            <span v-if="hensachiMode==2">高く運行しています。</span>
            <span v-else>安く運行できています！</span>
          </span>
        </div>
      </v-col>
    </v-row>
  </div>
</div>
</template>
<script>
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'

export default {
  name: 'DdNenpiSummaryDisp',
  mixins: [flowMixin],
  props: {
    /**
     * 抽出対象車両所属営業所IdList
     */
    eigyoshoIdList: Array,
    /**
     * 抽出対象燃費カテゴリIdList
     */
    nenpiCategoryIdList: Array,
    /**
     * ダッシュボード表示モード
     */
    dashBoardDispMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  data: () => ({
    kyuyuKingakuJisseki: 0,
    zenkokuShihyoKingaku: 0,
    kyuyuKingakuHensachi: 0,
    hensachiMode: 0,
    setHensachiTextColor: 'color: #2d71bf;',
    setHensachiIconColor: 'background-color: #2d71bf;',
    dataList: [],
    isLoading: false
  }),
  created () {
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    }
  },
  methods: {
    searchNenpiSummary: function (from, to) {
      this.isLoading = true
      const self = this
      if ([undefined, null, ''].includes(from) || [undefined, null, ''].includes(to)) { return }
      const rec = {
        searchTargetStartYmdString: from,
        searchTargetEndYmdString: to
      }
      self.HttpClient.post('/api/v1/D2FUED0040/KyuyuJissekiHensachiSearch', rec)
        .then((data) => {
          self.dataList = data.payload
          self.calcDispKingaku(self.eigyoshoIdList, self.nenpiCategoryIdList)
          self.isLoading = false
        })
    },
    calcDispKingaku: function (eigyoshoIdList, nenpiCategoryIdList) {
      const self = this
      let targetList = Object.assign({}, self.dataList)
      console.log(eigyoshoIdList)
      if (eigyoshoIdList.length > 0) {
        targetList = self.dataList.filter(function (elem) {
          return eigyoshoIdList.includes(elem.eigyoshoId)
        })
      }
      if (nenpiCategoryIdList.length > 0) {
        targetList = self.dataList.filter(function (elem) {
          return nenpiCategoryIdList.includes(elem.nenpiCategoryId)
        })
      }
      let kyuyuKingakuJissekiAmount = 0
      let zenkokuShihyoKingakuAmount = 0
      let kyuyuKingakuHensachiAmount = 0
      for (let i = 0; i < Object.keys(targetList).length; i++) {
        kyuyuKingakuJissekiAmount += targetList[i].kyuyuKingakuJissekiKei
        zenkokuShihyoKingakuAmount += targetList[i].zenkokuShihyoKingaku
        kyuyuKingakuHensachiAmount += targetList[i].kyuyuKingakuHensachi
      }
      self.kyuyuKingakuJisseki = filter.numericFormatter(kyuyuKingakuJissekiAmount)
      self.zenkokuShihyoKingaku = filter.numericFormatter(zenkokuShihyoKingakuAmount)
      self.kyuyuKingakuHensachi = filter.numericFormatter(Math.abs([kyuyuKingakuHensachiAmount]))
      if (kyuyuKingakuHensachiAmount < 0) {
        self.hensachiMode = 2
        self.setHensachiTextColor = 'color: #db4343;'
        self.setHensachiIconColor = 'background-color: #db4343;'
      } else if (kyuyuKingakuHensachiAmount > 0) {
        self.hensachiMode = 1
        self.setHensachiTextColor = 'color: #0ac80a;'
        self.setHensachiIconColor = 'background-color: #0ac80a;'
      } else {
        self.hensachiMode = 0
        self.setHensachiTextColor = 'color: #2d71bf;'
        self.setHensachiIconColor = 'background-color: #2d71bf;'
      }
    }
  }
}
</script>
<style scoped>
/* 上部バー機能定義 */
.kyuyu_summary_text_num {
    text-align: end !important;
    font: normal normal bold 54px/56px YuGothic !important;
    letter-spacing: 0px !important;
    color: #3178c5;
}
.kyuyu_summary_text {
    text-align: start !important;
    font: normal normal 30px/35px YuGothic !important;
    letter-spacing: 0px !important;
    margin-top: 18px;
    color: #1F2B38;
}
.kyuyu_info_text {
    font: normal normal 18px/20px YuGothic !important;
    color: #1F2B38;
}
.zenkoku_summary_text_num {
    text-align: end !important;
    font: normal normal bold 28px/30px YuGothic !important;
    color: #1F2B38;
}
.kyuyu_info_text_bold {
    font: normal normal bold 15px/17px YuGothic !important;
    color: #1F2B38;
}
.kyuyu_hensachi_icon{
    margin-left: 4px;
    padding-left: 10px;
    padding-right: 10px;
    text-align: start !important;
    font: normal normal 1.25rem YuGothic !important;
    color: #FFFFFF;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
}
.kyuyu_hensachi_num {
    font: normal normal bold 34px/36px YuGothic !important;
}
.kyuyu_hensachi_text {
    font: normal normal 15px/17px YuGothic !important;
}
.kyuyu_info_text_bold_dashboard {
    font: normal normal bold 28px/32px YuGothic !important;
    color: #1F2B38;
}
.kyuyu_hensachi_text_dashboard {
    font: normal normal 28px/32px YuGothic !important;
}
.kyuyu_hensachi_num_dashboard {
    font: normal normal bold 50px/92px YuGothic !important;
}

.donutSpinner {
  display: inline-block;
  border: 4px solid #E5EDFF;
  border-left-color: #5850EB;
  border-radius: 50%;
  width: 150px;
  height: 150px;
  animation: donut-spin 1.2s linear infinite;
}

@keyframes donut-spin {
  to {
    transform: rotate(1turn);
  }
}
</style>
